import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

function CookieConsent() {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);
  const [animateIn, setAnimateIn] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('kby_cookie_consent');
    if (!consent) {
      setVisible(true);
      // Trigger slide-up animation after mount
      const timer = setTimeout(() => setAnimateIn(true), 50);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('kby_cookie_consent', 'accepted');
    setAnimateIn(false);
    setTimeout(() => setVisible(false), 300);
  };

  const handleDecline = () => {
    localStorage.setItem('kby_cookie_consent', 'declined');
    setAnimateIn(false);
    setTimeout(() => setVisible(false), 300);
  };

  if (!visible) return null;

  const bannerStyle = {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    background: 'rgba(20, 20, 20, 0.95)',
    backdropFilter: 'blur(8px)',
    color: '#ccc',
    padding: '20px 24px',
    zIndex: 99998,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    fontSize: '14px',
    lineHeight: 1.6,
    fontFamily: 'inherit',
    borderTop: '1px solid rgba(255,255,255,0.08)',
    transform: animateIn ? 'translateY(0)' : 'translateY(100%)',
    opacity: animateIn ? 1 : 0,
    transition: 'transform 0.4s ease, opacity 0.3s ease',
  };

  const textStyle = {
    flex: '1 1 400px',
    textAlign: 'center',
    maxWidth: '700px',
  };

  const btnGroupStyle = {
    display: 'flex',
    gap: '10px',
    flexShrink: 0,
  };

  const acceptBtnStyle = {
    padding: '10px 24px',
    background: '#0bb4aa',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background 0.2s ease',
    whiteSpace: 'nowrap',
  };

  const declineBtnStyle = {
    padding: '10px 24px',
    background: 'transparent',
    color: '#aaa',
    border: '1px solid #555',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'border-color 0.2s ease, color 0.2s ease',
    whiteSpace: 'nowrap',
  };

  return (
    <div style={bannerStyle}>
      <div style={textStyle}>
        {t('cookie.message')}
      </div>
      <div style={btnGroupStyle}>
        <button
          onClick={handleAccept}
          style={acceptBtnStyle}
          onMouseEnter={(e) => (e.currentTarget.style.background = '#0da69d')}
          onMouseLeave={(e) => (e.currentTarget.style.background = '#0bb4aa')}
        >
          {t('cookie.accept')}
        </button>
        <button
          onClick={handleDecline}
          style={declineBtnStyle}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = '#888';
            e.currentTarget.style.color = '#ddd';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = '#555';
            e.currentTarget.style.color = '#aaa';
          }}
        >
          {t('cookie.decline')}
        </button>
      </div>
    </div>
  );
}

export default CookieConsent;
